module.exports = __webpack_public_path__ + "img/2.2d619f4f.jpg";